<template>
    <div>
        <div class="container bg-white p-4 mb-2">
            <div class="d-flex justify-content-between mb-3">
                <div class="mr-5">
                    <span class="text-gray-dk font-weight-bold font-md mb-3">Welcome to<br/> Home Credit Pay</span><br/>
                    <span class="text-secondary font-xs font-weight-medium">Shop and tap-to-pay from the safety of your home.</span>
                </div>
                <img alt="" src="/img/hcpay/hand-with-phone.svg" class="handWithPhone img-responsive">
            </div>
            <div class="d-flex rounded shadow-sm p-2">
                <img alt="" src="/img/hcpay/rebate.png" class="rebate img-responsive mr-3">
                <div class="d-block">
                    <span class="text-gray-dk font-weight-bold font-sm text-capitalize mb-3">earn rebates</span><br/>
                    <span class="d-block font-xxs text-secondary line-height-sm">Get cash back every time you pay with Home Credit Card! Valid for eligible transactions.</span>
                </div>
            </div>
        </div>
        <div class="container d-flex flex-column align-items-center bg-white p-4">
            <div class="font-md font-weight-bold text-gray-dk mb-3 align-self-start">How it works</div>
            <div class="d-flex align-items-start mb-2" v-for="howItWorks in howItWorksList" :key="howItWorks.key">
                <img alt="" :src="`/img/hcpay/${howItWorks.icon}.svg`" class="howItWorksIcon img-responsive mr-3 mt-1">
                <div>
                    <span class="text-gray-dk font-weight-bold font-sm">{{howItWorks.title}}</span><br/>
                    <span class="text-secondary font-xs font-weight-medium">{{howItWorks.description}}</span>
                </div>
            </div>
            <warning-bar class="my-4">Make sure the Home Credit app is installed on your phone and you have a stable network connection.</warning-bar>
            <div class="col-10 col-lg-8 mb-2">
                <button type="button" class="btn btn-success btn-block rounded-lg py-2 align-self-center" @click="changeView('verify-identity')">
                    <span class="font-xs">OK, got it!</span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            howItWorksList: [
                {
                    icon:'login-mobile',
                    title:'Login securely through the app',
                    description:'Simply enter your Facebook or mobile number, then login with the app to verify your identity.'
                },
                {
                    icon:'authorize-payment',
                    title:'Safely authorize your payment',
                    description:'Our servers are equipped with the latest industry-standard encryption.'
                },
                {
                    icon:'delivery',
                    title:'Enjoy your goods!',
                    description:'Once your payment is complete, it will be processed by the merchant for delivery.'
                }
            ]
        }
    },
    methods: {
        changeView(view) {
            this.$root.$data.view = view;
        },
    },
    created(){
        this.$root.$data.previousView = 'home';
    }
}
</script>
<style scoped>
    .handWithPhone {
        height:auto;
        width: 7rem;
    }

    .rebate {
        height: 72px;
        width: 80px;
    }

    .howItWorksIcon {
        height:auto;
        width: 3rem;
    }
</style>


